import React, { useEffect, useState } from "react";
import "./mainContent.css";
import EachCard from "./EachCard.js";
export default function MainContent(props) {
  const { data } = props;

  return (
    <div className="main_content_container">
      <div className="row">
          {data.map((val, index) => {
            return <EachCard data={val} index={index} key={index} />;
          })}
      </div>
    </div>
  );
}
